(() => {
  if (window.__GOCLP_FILTERS_V2__) return;
  window.__GOCLP_FILTERS_V2__ = true;

  const LABELS = window.__GOC_LABELS__ || {};
  const MQ_DESKTOP = window.matchMedia("(min-width: 990px)");
  const PER_PAGE = 250;
  const productsCache = new Map(); // handle -> Promise<products[]>

  let APPLY_SEQ = 0;
  let APPLY_CTRL = null;

  const $ = (root, sel) => root.querySelector(sel);
  const $$ = (root, sel) => Array.from(root.querySelectorAll(sel));

  function safeJsonParse(el) {
    try { return JSON.parse(el.textContent || "{}"); } catch { return {}; }
  }

  function cssEscapeAttr(s) {
    return String(s || "").replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  }



  function groupFromTag(tag) {
    const s = String(tag || "");
    const i = s.indexOf("_");
    return (i > -1 ? s.slice(0, i) : s).trim().toLowerCase();
  }

  function normalizeCollectionBase(collectionUrl, collectionHandle) {
    try {
      const u = new URL(collectionUrl || "", window.location.origin);
      // trim anything after /collections/<handle>
      const m = u.pathname.match(/^(.*\/collections\/[^\/]+)(?:\/.*)?$/);
      const base = (m && m[1]) ? m[1] : (u.pathname || "");
      return base.replace(/\/$/, "");
    } catch (e) {
      return collectionHandle ? ("/collections/" + collectionHandle) : (collectionUrl || "");
    }
  }

  async function fetchAllCollectionProducts(handle, totalCount) {
    const key = String(handle || "");
    if (!key) return [];
    if (productsCache.has(key)) return productsCache.get(key);

    const promise = (async () => {
      const pages = Math.max(1, Math.ceil((Number(totalCount) || 0) / PER_PAGE));
      const all = [];

      for (let p = 1; p <= pages; p++) {
        const url = `/collections/${encodeURIComponent(key)}/products.json?limit=${PER_PAGE}&page=${p}`;
        const res = await fetch(url, { credentials: "same-origin" });
        if (!res.ok) break;
        const json = await res.json();
        const products = Array.isArray(json.products) ? json.products : [];
        all.push(...products);
        if (products.length < PER_PAGE) break;
      }

      return all.map(prod => {
        const tagsRaw = prod.tags;
        const tagsArr = Array.isArray(tagsRaw)
          ? tagsRaw
          : String(tagsRaw || "").split(",").map(s => s.trim()).filter(Boolean);

        return { ...prod, __tagsSet: new Set(tagsArr) };
      });
    })();

    productsCache.set(key, promise);
    return promise;
  }

  function matchesAll(prod, requiredTags) {
    for (const t of requiredTags) {
      if (!prod.__tagsSet.has(t)) return false;
    }
    return true;
  }

function getTagHandleFromDOM(root, tag) {
  const el = root.querySelector(`[data-goc-tag="${cssEscapeAttr(tag)}"]`);
  const h = el && el.getAttribute("data-goc-tag-handle");
  if (h) return h;

 // fallback: DO NOT drop decimals -> 10.5 => 10-5
  return String(tag || "")
    .normalize("NFKD").replace(/[\u0300-\u036f]/g, "")
    .toLowerCase().trim()
    // convert decimal dot to dash
    .replace(/(\d)\.(\d)/g, "$1-$2")
    // normalize spaces to dash
    .replace(/\s+/g, "-")
    // keep underscore and dash, drop other junk
    .replace(/[^a-z0-9_-]+/g, "")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function buildUrl(state, root, activeTags, sortBy) {
  const tags = Array.from(activeTags || []);
  const tagHandles = tags.map(t => getTagHandleFromDOM(root, t)).filter(Boolean).join("+");

  const base = state.collectionBase || state.collectionUrl || (`/collections/${state.collectionHandle}`);
  const path = tagHandles ? `${base}/${tagHandles}` : base;

  const u = new URL(path, window.location.origin);
  if (sortBy) u.searchParams.set("sort_by", sortBy);
  return u;
}

function buildMetafieldUrl(state, sortBy) {
  const base = state.collectionBase || state.collectionUrl || `/collections/${state.collectionHandle}`;
  const u = new URL(base, window.location.origin);
  for (const [p, v] of Object.entries(state.__activeMetafilters || {})) {
    if (v) u.searchParams.set(p, v);
  }
  if (sortBy) u.searchParams.set("sort_by", sortBy);
  return u;
}


  function setSortMenuState(root, sortBy) {
    const menu = $(root, "[data-goc-sort-menu]");
    if (!menu) return;
    $$(menu, "[data-goc-sort-by]").forEach(btn => {
      btn.classList.toggle("is-active", btn.getAttribute("data-goc-sort-by") === sortBy);
    });
  }

 function setFiltersLabel(root) {
  const label = $(root, "[data-goc-filters-label]");
  if (!label) return;

  if (!MQ_DESKTOP.matches) {
    label.textContent = LABELS.filters;
    return;
  }

  const hidden = root.classList.contains("gocplp--filtersHidden");
  label.textContent = hidden ? LABELS.showFilters : LABELS.hideFilters;
}

  function closeSortMenu(root) {
    const btn = $(root, "[data-goc-sort-toggle]");
    const menu = $(root, "[data-goc-sort-menu]");
    if (!btn || !menu) return;
    btn.setAttribute("aria-expanded", "false");
    menu.hidden = true;
  }

  function toggleSortMenu(root) {
    const btn = $(root, "[data-goc-sort-toggle]");
    const menu = $(root, "[data-goc-sort-menu]");
    if (!btn || !menu) return;
    const open = menu.hidden;
    btn.setAttribute("aria-expanded", open ? "true" : "false");
    menu.hidden = !open;
  }

  async function updateCounts(root, state) {
    // Include [data-goc-filters] in root AND in teleported drawers that belong to this root
    const filtersRoots = Array.from(document.querySelectorAll("[data-goc-filters]"))
      .filter(el => root.contains(el) || el.closest("[data-goc-drawer]")?.__gocRoot === root);
    if (!filtersRoots.length) return;

    const products = await fetchAllCollectionProducts(state.collectionHandle, state.productsCount);
    const activeTags = state.__activeTags;

    for (const filtersRoot of filtersRoots) {
      const items = $$(filtersRoot, "[data-goc-tag]");
      for (const el of items) {
        const tag = el.getAttribute("data-goc-tag");
        const group = (el.getAttribute("data-goc-group") || groupFromTag(tag)).toLowerCase();
        const isActive = activeTags.has(tag);

        // required tags = active tags from OTHER groups
        const required = [];
        for (const t of activeTags) {
          if (groupFromTag(t) !== group) required.push(t);
        }

        let cnt = 0;
        for (const prod of products) {
          if (!prod.__tagsSet.has(tag)) continue;
          if (matchesAll(prod, required)) cnt++;
        }

        const countEl = el.querySelector("[data-goc-count]");
        if (countEl) countEl.textContent = `(${cnt})`;

        const label = el.getAttribute("data-goc-label") || "";
        if (label) {
          el.setAttribute("aria-label", `${label} (${cnt})`);
          el.setAttribute("title", `${label} (${cnt})`);
        }

        const shouldDisable = cnt === 0 && !isActive;
        if ("disabled" in el) el.disabled = shouldDisable;
        el.classList.toggle("is-disabled", shouldDisable);
      }
    }
  }

  async function fetchSectionHTML(urlObj, state, signal) {
    // 1) preferred: ?sections=<sectionId>  (JSON)
    const u1 = new URL(urlObj.toString());
    u1.searchParams.set("sections", state.sectionId);

    const r1 = await fetch(u1.toString(), {
      credentials: "same-origin",
      signal,
      headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "application/json" }
    });

    if (r1.ok) {
      const ct = (r1.headers.get("content-type") || "").toLowerCase();
      if (ct.includes("application/json")) {
        const json = await r1.json();
        if (json && json[state.sectionId]) return json[state.sectionId];
      } else {
        const txt = await r1.text();
        if (txt && txt.includes("data-goc-grid")) return txt;
      }
    }

    // 2) fallback: ?section_id=<handle> (HTML)
    const u2 = new URL(urlObj.toString());
    u2.searchParams.set("section_id", state.sectionHandle || LABELS.sectionHandle || "goc-plp-main");

    const r2 = await fetch(u2.toString(), {
      credentials: "same-origin",
      signal,
      headers: { "X-Requested-With": "XMLHttpRequest" }
    });

    if (!r2.ok) return "";
    return await r2.text();
  }

  async function ajaxApply(root, state, { push = true } = {}) {
    const u = state.filterMode === "metafields"
      ? buildMetafieldUrl(state, state.__sortBy)
      : buildUrl(state, root, state.__activeTags, state.__sortBy);

    APPLY_SEQ += 1;
    const seq = APPLY_SEQ;

    if (APPLY_CTRL) APPLY_CTRL.abort();
    APPLY_CTRL = new AbortController();
    const { signal } = APPLY_CTRL;

    root.classList.add("gocplp--loading");

    try {
      const html = await fetchSectionHTML(u, state, signal);
      if (!html) throw new Error("Empty section HTML");

      if (seq !== APPLY_SEQ) return;

      const doc = new DOMParser().parseFromString(html, "text/html");

      const newGrid = doc.querySelector("[data-goc-grid]");
      const curGrid = root.querySelector("[data-goc-grid]");
      if (!newGrid || !curGrid) {
        window.location.assign(u.toString());
        return;
      }

      curGrid.replaceWith(newGrid);
      window.dispatchEvent(new Event("goc:reviews:refresh"));
      // keep pagination/loader in sync too
      const newInf = doc.querySelector("[data-goc-infinite]");
      const curInf = root.querySelector("[data-goc-infinite]");
      if (curInf) {
        if (newInf) curInf.replaceWith(newInf);
        else curInf.remove();
      } else if (newInf) {
        const gridNow = root.querySelector("[data-goc-grid]");
        if (gridNow) gridNow.after(newInf);
      }

      if (push) history.pushState({ gocplp: true, url: u.toString() }, "", u.toString());

      setFiltersLabel(root);
      setSortMenuState(root, state.__sortBy);

      if (state.filterMode === "metafields") {
        // Sync is-active states from JS state — do not replace sidebar from server
        // (published theme may differ from customizer preview settings)
        const allFilterContainers = [
          ...Array.from(root.querySelectorAll("[data-goc-filters]")),
          ...Array.from(document.querySelectorAll("[data-goc-drawer] [data-goc-filters]"))
            .filter(el => el.closest("[data-goc-drawer]").__gocRoot === root)
        ];
        allFilterContainers.forEach(container => {
          container.querySelectorAll("[data-goc-filter-value]").forEach(btn => {
            const param = btn.getAttribute("data-goc-filter-param");
            const value = btn.getAttribute("data-goc-filter-value");
            const isActive = (state.__activeMetafilters || {})[param] === value;
            btn.classList.toggle("is-active", isActive);
            btn.setAttribute("data-active", JSON.stringify(isActive));
          });
        });
      } else {
        updateCounts(root, state).catch(() => {});
      }
      root.dispatchEvent(new CustomEvent("gocplp:updated", { bubbles: true }));
    } catch (err) {
      if (err && err.name === "AbortError") return;
      window.location.assign(u.toString());
    } finally {
      if (seq === APPLY_SEQ) root.classList.remove("gocplp--loading");
    }
  }

  function getFilterContainers(root) {
    // Include both in-root elements and teleported drawers belonging to this root
    const inRoot = Array.from(root.querySelectorAll("[data-goc-group-key]"));
    const teleported = Array.from(document.querySelectorAll("[data-goc-drawer] [data-goc-group-key]"))
      .filter(el => {
        const drawer = el.closest("[data-goc-drawer]");
        return drawer && drawer.__gocRoot === root && !root.contains(drawer);
      });
    return [...inRoot, ...teleported];
  }

  function isOwnedByRoot(el, root) {
    if (root.contains(el)) return true;
    const drawer = el.closest("[data-goc-drawer]");
    return drawer && drawer.__gocRoot === root;
  }

  function syncGroupUI(root, groupKey, activeTagOrNull) {
    const gSel = `[data-goc-group-key="${CSS.escape(groupKey)}"]`;
    getFilterContainers(root).filter(g => g.matches(gSel)).forEach(group => {
      $$(group, "[data-goc-tag]").forEach(btn => btn.classList.remove("is-active"));
      if (activeTagOrNull) {
        const tSel = `[data-goc-tag="${cssEscapeAttr(activeTagOrNull)}"]`;
        const activeBtn = group.querySelector(tSel);
        if (activeBtn) activeBtn.classList.add("is-active");
      }
    });
  }
  // ============================================================
  // Mobile drawer scroll lock (filters) — no background scroll
  // ============================================================
  const SCROLL = {
    activeDrawer: null,
    bound: false,
    onTouch: null,
    onWheel: null
  };

  function isQuickAddOpen() {
    const qa = document.querySelector(".gocqa[aria-hidden='false']");
    return !!qa;
  }

  function lockScrollForDrawer(drawerEl) {
    SCROLL.activeDrawer = drawerEl;

    // class-based (preferred) + fallback to inline
    document.documentElement.classList.add("goc-scrolllock");
    document.documentElement.style.overflow = "hidden";

    if (SCROLL.bound) return;
    SCROLL.bound = true;

    SCROLL.onTouch = (e) => {
      const d = SCROLL.activeDrawer;
      if (!d) return;

      // allow scrolling INSIDE drawer only
      if (!d.contains(e.target)) e.preventDefault();
    };

    SCROLL.onWheel = (e) => {
      const d = SCROLL.activeDrawer;
      if (!d) return;

      if (!d.contains(e.target)) e.preventDefault();
    };

    document.addEventListener("touchmove", SCROLL.onTouch, { passive: false, capture: true });
    document.addEventListener("wheel", SCROLL.onWheel, { passive: false, capture: true });
  }

  function unlockScrollForDrawer() {
    SCROLL.activeDrawer = null;

    if (isQuickAddOpen()) return;

    document.documentElement.classList.remove("goc-scrolllock");
    document.documentElement.style.overflow = "";

    if (!SCROLL.bound) return;
    SCROLL.bound = false;

    document.removeEventListener("touchmove", SCROLL.onTouch, { capture: true });
    document.removeEventListener("wheel", SCROLL.onWheel, { capture: true });

    SCROLL.onTouch = null;
    SCROLL.onWheel = null;
  }

  function openFiltersDrawerMobile(root) {
    const drawer = root.querySelector('[data-goc-drawer="filters"]')
                || document.querySelector('[data-goc-drawer="filters"]');
    if (!drawer) return;

    // Position drawer flush below the full header section (includes announcement bar)
    const headerSection = document.querySelector('.cn-header-wrapper')
                        ?.closest('[id^="shopify-section-"]');
    const headerEl = headerSection || document.querySelector('.cn-header-wrapper');
    if (headerEl) {
      drawer.style.top = headerEl.getBoundingClientRect().bottom + 'px';
    }

    drawer.hidden = false;
    drawer.dataset.open = "1";

    lockScrollForDrawer(drawer);

    if (!drawer.__gocScrollObs) {
      drawer.__gocScrollObs = new MutationObserver(() => {
        const closed = drawer.hidden || !drawer.dataset.open;
        if (closed) {
          unlockScrollForDrawer();
          try { drawer.__gocScrollObs.disconnect(); } catch(e) {}
          drawer.__gocScrollObs = null;
        }
      });
      drawer.__gocScrollObs.observe(drawer, { attributes: true, attributeFilter: ["hidden", "data-open"] });
    }
  }

  function closeFiltersDrawerMobile(root) {
    const drawer = root.querySelector('[data-goc-drawer="filters"]')
                || document.querySelector('[data-goc-drawer="filters"]');
    if (!drawer) return;

    drawer.hidden = true;
    delete drawer.dataset.open;
    unlockScrollForDrawer();
  }

  function init(root) {
    const stateEl = $(root, "[data-gocplp-state]");
    if (!stateEl) return;

    const raw = safeJsonParse(stateEl);

    const grid = root.querySelector("[data-goc-grid]");
    const sectionHandle = (grid && grid.dataset.sectionHandle) ? grid.dataset.sectionHandle : "goc-plp-main";

    const state = {
      sectionId: raw.sectionId,
      sectionHandle,
      collectionUrl: raw.collectionUrl,
      collectionHandle: raw.collectionHandle,
      collectionBase: normalizeCollectionBase(raw.collectionUrl, raw.collectionHandle),
      productsCount: raw.productsCount,
      __activeTags: new Set(raw.tags || []),
      __sortBy: raw.sortBy || null,
      __pendingMobile: false,
      __pendingMobileUrl: null,
      __activeMetafilters: {},
      filterMode: raw.filterMode || "tags"
    };

    root.__gocplpState = state;
// read tags from URL path (…/collections/handle/<tag1+tag2>)
(function syncStateFromURL() {
  try {
    const base = (state.collectionBase || "").replace(/\/$/, "");
    const path = window.location.pathname.replace(/\/$/, "");

    if (base && path.startsWith(base + "/")) {
      const tail = path.slice(base.length + 1);
      const seg = tail.split("/")[0]; // tag segment
      const handles = seg.split("+").map(s => decodeURIComponent(s)).filter(Boolean);

      if (handles.length) {
        // map handle -> tag using DOM
        const map = new Map();
        $$(root, "[data-goc-tag]").forEach(el => {
          const t = el.getAttribute("data-goc-tag");
          const h = el.getAttribute("data-goc-tag-handle");
          if (t && h) map.set(h, t);
        });

        state.__activeTags = new Set(handles.map(h => map.get(h)).filter(Boolean));

        // sync UI per group
        for (const t of state.__activeTags) {
          const g = groupFromTag(t);
          syncGroupUI(root, g, t);
        }
      }
    }

    const sp = new URL(window.location.href).searchParams.get("sort_by");
    if (sp) state.__sortBy = sp;
  } catch (e) {}
})();

    setFiltersLabel(root);
    setSortMenuState(root, state.__sortBy);
    updateCounts(root, state).catch(() => {});

    // Filter/sort click handler — shared between root and teleported drawers
    function handleFilterClick(e) {
      // Filters toggle
      const filtersBtn = e.target.closest("[data-goc-filters-toggle]");
      if (filtersBtn) {
        e.preventDefault();

        if (MQ_DESKTOP.matches) {
          root.classList.toggle("gocplp--filtersHidden");
          setFiltersLabel(root);
          return;
        }

        openFiltersDrawerMobile(root);
        return;
      }

      // Sort toggle (desktop)
     const sortBtn = e.target.closest("[data-goc-sort-toggle]");
      if (sortBtn) {
        e.preventDefault();
        toggleSortMenu(root);
        return;
      }

      // Sort pick (desktop)
      const sortPick = e.target.closest("[data-goc-sort-by]");
if (sortPick) {
  e.preventDefault();

  state.__sortBy = sortPick.getAttribute("data-goc-sort-by") || null;
  setSortMenuState(root, state.__sortBy);
  closeSortMenu(root);
  ajaxApply(root, state);
  return;
}

      // Clear
      const clear = e.target.closest("[data-goc-clear], .gocf__clear");
      if (clear && isOwnedByRoot(clear, root)) {
        if (clear.tagName === "A") e.preventDefault();

        state.__activeTags.clear();
        getFilterContainers(root).forEach(group => {
          $$(group, "[data-goc-tag]").forEach(btn => btn.classList.remove("is-active"));
        });

        state.__pendingMobile = false;
        ajaxApply(root, state);
        return;
      }

      // Apply (mobile drawer)
      const applyBtn = e.target.closest("[data-goc-apply]");
      if (applyBtn && isOwnedByRoot(applyBtn, root)) {
        e.preventDefault();
        state.__pendingMobile = false;
        // CLOSE + unlock scroll
        closeFiltersDrawerMobile(root);
        ajaxApply(root, state);
        return;
      }

      // Filter option click — TAG mode
      const opt = e.target.closest("[data-goc-tag]");
      if (opt && opt.closest("[data-goc-filters]") && state.filterMode !== "metafields") {
        e.preventDefault();
        e.stopPropagation();

        const tag = opt.getAttribute("data-goc-tag");
        const group = (opt.getAttribute("data-goc-group") || groupFromTag(tag)).toLowerCase();

        // remove other tag from same group
        for (const t of Array.from(state.__activeTags)) {
          if (groupFromTag(t) === group) state.__activeTags.delete(t);
        }

        const wasActive = opt.classList.contains("is-active");
        if (!wasActive) state.__activeTags.add(tag);

        // sync UI across desktop + drawer
        syncGroupUI(root, group, wasActive ? null : tag);

        updateCounts(root, state).catch(() => {});

        // desktop: apply immediately
        if (MQ_DESKTOP.matches) {
          ajaxApply(root, state);
        } else {
          // mobile: wait for Apply button (since you have it)
          state.__pendingMobile = true;
        }
        return;
      }

      // Filter option click — METAFIELD mode (Storefront Filtering API)
      const mfOpt = e.target.closest("[data-goc-filter-value]");
      if (mfOpt && mfOpt.closest("[data-goc-filters]") && state.filterMode === "metafields") {
        e.preventDefault();
        e.stopPropagation();

        const param = mfOpt.getAttribute("data-goc-filter-param");
        const value = mfOpt.getAttribute("data-goc-filter-value");
        const wasActive = mfOpt.classList.contains("is-active");

        // Init metafield params tracker if needed
        if (!state.__activeMetafilters) state.__activeMetafilters = {};

        // Single-select per group: clear same group
        if (wasActive) {
          delete state.__activeMetafilters[param];
        } else {
          state.__activeMetafilters[param] = value;
        }

        // Sync UI across root + teleported drawers
        const mfSel = `[data-filter-param="${param}"] [data-goc-filter-value]`;
        $$(root, mfSel).forEach(btn => btn.classList.remove("is-active"));
        document.querySelectorAll("[data-goc-drawer]").forEach(d => {
          if (d.__gocRoot === root && !root.contains(d)) {
            $$(d, mfSel).forEach(btn => btn.classList.remove("is-active"));
          }
        });
        if (!wasActive) {
          // Activate in all copies (drawer + sidebar)
          const activeSel = `[data-goc-filter-value="${cssEscapeAttr(value)}"]`;
          $$(root, activeSel).forEach(btn => btn.classList.add("is-active"));
          document.querySelectorAll("[data-goc-drawer]").forEach(d => {
            if (d.__gocRoot === root && !root.contains(d)) {
              $$(d, activeSel).forEach(btn => btn.classList.add("is-active"));
            }
          });
        }

        // Build URL with filter params
        const filterUrl = new URL(state.collectionBase || state.collectionUrl, window.location.origin);
        for (const [p, v] of Object.entries(state.__activeMetafilters)) {
          if (v) filterUrl.searchParams.set(p, v);
        }
        if (state.__sortBy) filterUrl.searchParams.set("sort_by", state.__sortBy);

        if (MQ_DESKTOP.matches) {
          ajaxApply(root, state);
        } else {
          state.__pendingMobile = true;
        }
        return;
      }
    }

    // Bind on root (for desktop sidebar filters, sort, etc.)
    root.addEventListener("click", handleFilterClick, true);

    // Also bind on teleported drawers so filter clicks work on mobile
    document.querySelectorAll("[data-goc-drawer]").forEach(d => {
      if (d.__gocRoot === root && !root.contains(d)) {
        d.addEventListener("click", handleFilterClick, true);
      }
    });

    // close sort on outside click
    document.addEventListener("click", (e) => {
    if (!root.contains(e.target)) closeSortMenu(root);
  const menu = $(root, "[data-goc-sort-menu]");
  if (menu && !menu.hidden && !e.target.closest("[data-goc-sort]")) closeSortMenu(root);
    }, true);

    // back/forward
    window.addEventListener("popstate", (ev) => {
      if (!ev.state || !ev.state.gocplp) return;
      ajaxApply(root, state, { push: false });
    });
  }

  function boot() {
    document.querySelectorAll("[data-gocplp-state]").forEach(el => {
      const root = el.closest(".gocplp") || el.closest("[data-goc-plp]");
      if (root) init(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
